<header class="container-fluid">
    <div class="row flex-nowrap align-items-center justify-content-between">
        <div class="col-auto flex-shrink-1">
            <button type="button" class="btn-back mat-elevation-z0 px-2 pr-sm-3" mat-flat-button color="gray" (click)="onBack()" *ngIf="showBack">
            <mat-icon>chevron_left</mat-icon>
            <span class="font-weight-light d-none d-sm-inline">{{ 'general.back' | translate }}</span>
            </button>
            <div class="mat-subheading-2 ml-3 mb-0">
                <ng-content></ng-content>
                <span class="text-blue d-block d-md-inline" *ngIf="agent">
                    <span class="d-none d-sm-inline">{{ 'header.agent' | translate }}: </span>
                <strong>{{ agent.name }} {{ agent.surname }}</strong>
                </span>
            </div>
        </div>
        <div class="col-auto justify-content-end">
            <button type="button" class="btn-wrapper mat-elevation-z0" mat-flat-button color="blue" (click)="onExit()">
                <i class="icon-exit mb-2"></i>
                <span class="font-weight-light" [innerHTML]="'header.exit' | translate"></span>
            </button>
        </div>
    </div>
</header>